import { useQuery } from '@tanstack/react-query';

import { Alert, Loader, api, getQueryProps, parseError } from 'common';

import { BlockAutocomplete } from '../scenes/Agents/Flows/ReactFlow/Nodes/ConfigFields/Autocomplete';

interface Props {
  fieldName: string;
  organizationId: string;
  helperText: string;
}

export function DecisionTreeSelect(props: Props) {
  const { fieldName, organizationId, helperText } = props;
  const {
    data: decisionTrees,
    isPending,
    error,
  } = useQuery({
    ...getQueryProps(api.client.DecisionTree, 'findAll', {
      organizationIds: [organizationId],
    }),
  });

  if (isPending) {
    return <Loader />;
  }
  if (error) {
    return <Alert title="Error">{parseError(error)}</Alert>;
  }
  return (
    <BlockAutocomplete
      fieldName={fieldName}
      label="Decision Tree"
      options={decisionTrees?.map((tree) => tree.id) ?? []}
      getOptionLabel={(treeId) => {
        const tree = decisionTrees?.find((tree) => tree.id === treeId);
        return tree?.name ?? treeId;
      }}
      loading={isPending}
      helperText={helperText}
    />
  );
}
